import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { RolodexEntryPatchJson } from 'types'

import { KVMessageDef } from './index'

export function getSetMeasurementScaleMessage(): KVMessageDef {
  return {
    type: 'setMeasurementScale',
    requiredData: ['measurementScale'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      if (kv.kestrelModel) {
        const patchData: RolodexEntryPatchJson = {
          id: kv.kestrelModel.id,
          data: {
            measurementScale: json.measurementScale,
          },
        }
        kv.rolodexPatch([patchData])
      }
    },
  }
}
